import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@jem-open/jem-ui';
import { environment } from '../../../environment/environment';
import { DataTable } from '../../../components/DataTable';
import { EmptyState } from '../../../components/EmptyState';

/**
 * @summary SubscriptionBatchItemsModal component
 *
 * @param {Props} props
 * @component
 */
const SubscriptionBatchItemsModal = (props) => {
  const [state, setState] = useState({
    batchSubscriptions: null,
    loading: true,
  });
  const { toggleBatchItemsModal, handleShowBatchItemsModal, activeBatch } =
    props;

  const getSubscriptions = () => {
    setState((prev) => ({ ...prev, loading: true }));
    axios
      .get(`${environment.baseUrl}/subscription_batch/${activeBatch.id}/report`)
      .then((res) => {
        setState((prev) => ({
          ...prev,
          batchSubscriptions: res.data,
          loading: false,
        }));
      })
      .catch(() => {
        setState((prev) => ({ ...prev, loading: false }));
      });
  };

  useEffect(() => {
    getSubscriptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    { key: 'id', label: 'ID', width: '80px' },
    { key: 'employee_amount', label: 'Employee Amount' },
    { key: 'employer_amount', label: 'Employer Amount' },
  ];

  const emptyState = (
    <EmptyState
      icon="fas fa-layer-group"
      message="This batch has no linked subscriptions"
    />
  );

  return (
    <Dialog
      open={toggleBatchItemsModal}
      onOpenChange={(next) => {
        if (!next) handleShowBatchItemsModal();
      }}>
      <DialogContent className="flex max-h-[85vh] flex-col sm:max-w-3xl">
        <DialogHeader>
          <DialogTitle>Subscription Batch Items</DialogTitle>
        </DialogHeader>

        <div className="min-h-0 flex-1 overflow-y-auto">
          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={
                Array.isArray(state.batchSubscriptions)
                  ? state.batchSubscriptions
                  : []
              }
              loading={state.loading}
              emptyState={emptyState}
              skeletonRows={6}
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleShowBatchItemsModal}>
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

SubscriptionBatchItemsModal.defaultProps = {
  activeBatch: null,
};

SubscriptionBatchItemsModal.propTypes = {
  toggleBatchItemsModal: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
    .isRequired,
  handleShowBatchItemsModal: PropTypes.func.isRequired,
  activeBatch: PropTypes.shape({
    id: PropTypes.string,
  }),
};

export default SubscriptionBatchItemsModal;
